// removed by extract-text-webpack-plugin
module.exports = {"EducationItem":"EducationItem__EducationItem___1X0Nm","SchoolHeading":"EducationItem__SchoolHeading___30Ggu","DegreeTitle":"EducationItem__DegreeTitle___UT1GF","SchoolTitle":"EducationItem__SchoolTitle___osyIA","Timeline":"EducationItem__Timeline___uwc1w","Company":"EducationItem__Company___uFpTs","Description":"EducationItem__Description___pntro","clearfix":"EducationItem__clearfix___2jQSh"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ResumeBox/Resume/Education/EducationItem/EducationItem.css
// module id = 42
// module chunks = 0